import React from "react";
import { Commet } from "react-loading-indicators";

const Loader = () => {
  return (
    <div className="flex justify-center items-center mx-auto h-screen">
      <Commet color="#FF6C6C" size="large" text="" textColor="" />
    </div>
  );
};

export default Loader;
